<template>
    <div class="default-layout">
        <van-collapse v-model="activeNames">
            <van-collapse-item name="basicInformation" title="基本信息">
                <basic-information-view :region="region" :viewedOriginCertificate="viewedOriginCertificate"
                                        ref="basicInformation"></basic-information-view>
            </van-collapse-item>

            <van-collapse-item name="exportInvoice" title="出口发票">
                <export-invoice-card-view
                        :viewedOriginCertificateInvoices="viewedOriginCertificate.originCertificateInvoices"
                        ref="exportInvoiceCard"></export-invoice-card-view>
            </van-collapse-item>

            <van-collapse-item name="exportProduct" title="出口商品">
                <export-product-card-view
                        :viewedOriginCertificateProducts="viewedOriginCertificate.originCertificateProducts"
                        ref="exportProductCard"></export-product-card-view>
            </van-collapse-item>

            <van-collapse-item v-if="checkPictureMark(region.value)" name="pictureMark" title="附件-图片唛头">
                <picture-mark-card-view :viewedOriginCertificateMarks="viewedOriginCertificate.originCertificateMarks"
                                        ref="pictureMarkCard"></picture-mark-card-view>
            </van-collapse-item>

            <van-collapse-item name="evidenceData" title="附件-佐证资料（运输单据和商业发票）">
                <evidence-data-card-view
                        :viewedOriginCertificateEvidences="viewedOriginCertificate.originCertificateEvidences"
                        ref="evidenceDataCard"></evidence-data-card-view>
            </van-collapse-item>

            <van-collapse-item name="additionalInformation" title="补充信息">
                <additional-information-view :region="region" :viewedOriginCertificate="viewedOriginCertificate"
                                             ref="additionalInformation"></additional-information-view>
            </van-collapse-item>

        </van-collapse>

    </div>
</template>

<script>
    import BasicInformationView from './basic/PrefBasicInformationView'
    import ExportInvoiceCardView from '../../origin-certificate/view/invoice/ExportInvoiceCardView'
    import ExportProductCardView from './product/PrefExportProductCardView'
    import PictureMarkCardView from '../../origin-certificate/view/picturemark/PictureMarkCardView'
    import EvidenceDataCardView from '../../origin-certificate/view/evidencedata/EvidenceDataCardView'
    import AdditionalInformationView from './additional/PrefAdditionalInformationView'
    import originCertificateRegion from '../../origin-certificate/service/origin-certificate-region'

    export default {
        name: "PrefApplicationOrderDetail",
        data() {
            return {
                activeNames: [
                    'basicInformation','exportInvoice','exportProduct',
                    'pictureMark','evidenceData','additionalInformation'
                ],
                viewedOriginCertificate: null,
                region:null
            }
        },
        components: {
            BasicInformationView,
            ExportInvoiceCardView,
            ExportProductCardView,
            PictureMarkCardView,
            EvidenceDataCardView,
            AdditionalInformationView,
        },
        computed: {},
        created() {
            this.viewedOriginCertificate = JSON.parse(this.$route.query.viewedOriginCertificate);
            this.region = originCertificateRegion.valueOf(this.viewedOriginCertificate.regionCode);
            this.$route.meta.title = this.region.label;
        },
        methods: {
          checkPictureMark(value) {
            return originCertificateRegion.checkPictureMark(value)
          },
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/app-theme/style/rcep-layout";
</style>